<template>
    <v-dialog :value="!!prompt" max-width="480px" persistent>
        <v-card v-if="prompt">
            <v-card-title>Mark the organiser as Paid in Full?</v-card-title>
            <v-card-text>
                <p>
                    {{ prompt.lead_name }} paid {{ money(prompt.paid) }} for this package while it was
                    {{ money(prompt.old_total) }}. It's now {{ money(prompt.new_total) }}, so they'll show as
                    {{ money(prompt.new_total - prompt.paid) }} short.
                </p>
                <p class="mb-0">
                    If they had the organiser discount (e.g. £50 off), mark them as Paid in Full. No payment is
                    recorded, and you can undo it from Event → Invitees → organiser ⋮ → Mark as Unpaid.
                </p>
            </v-card-text>
            <v-card-actions class="custom-buttons">
                <v-spacer></v-spacer>
                <v-btn text :disabled="saving" @click="$emit('close')">No, they still owe it</v-btn>
                <v-btn dark color="#3988AA" :loading="saving" @click="markPaid()">Mark as Paid in Full</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from "vuex"

// After a quote edit raises a booked package's price back up, when the organiser paid exactly the
// old price (the API's organiser_paid_at_old_price, LeadService::organiserPaidAtOldPrice): offer
// to mark them Paid in Full (No Payment), same as Event → Invitees → organiser ⋮.
export default {
    props: {
        // { lead_id, lead_name, event_id, event_name, company_id, quote_id, paid, old_total, new_total } or null
        prompt: { type: Object, default: null },
    },
    data: () => ({
        saving: false,
    }),
    computed: {
        ...mapGetters({
            get_selected_company: 'auth/get_selected_company',
        }),
    },
    methods: {
        money(amount) {
            return `${this.get_selected_company?.currency || ''}${Number(amount || 0).toFixed(2)}`
        },
        async markPaid() {
            const prompt = this.prompt
            this.saving = true
            try {
                const result = (await this.$axios.post(`admin/leads/mark_lead_as_paid/${prompt.lead_id}`, {
                    event_id: prompt.event_id,
                    company_id: prompt.company_id,
                    total_paid_amount: 0,
                    payment_date: this.$date().format('YYYY-MM-DD HH:mm:ss'),
                    reference_code: `Marked paid (no payment) - ${Date.now()}`,
                    event_name: prompt.event_name,
                    quote_id: prompt.quote_id,
                    paid_by: prompt.lead_id,
                    payment_type_id: 1,
                    payment_gateway: 'Manual',
                })).data
                if (result.response == true) {
                    this.$toast.success(`${prompt.lead_name} marked as Paid in Full`)
                    this.$emit('close')
                } else {
                    this.$toast.error('Failed to mark the organiser as paid')
                }
            } catch (e) {
                this.$toast.error('Failed to mark the organiser as paid')
            } finally {
                this.saving = false
            }
        },
    },
}
</script>
